import React, { Component } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import DatePickerField from "../../../../../components/inputs/datepicker";
import TextField from "../../../../../components/inputs/textfield";
import Snackbar from "../../../../../components/snackbar/snackbar";

import Loader from "../../../../../components/loader/loader";
import {
  admin_advertisement_add,
  admin_advertisement_update,
  admin_notification_add,
  admin_notification_update,
  advertisement_approve_status,
  advertisement_revert_status,
} from "../../../admin.api";
import "./dialog.css";
import TextEditer from "../../../../../components/inputs/texteditor";
import Swal from "sweetalert2";

let required = [
  "start_date",
  "end_date",
  "title",
  "advertisement",
  "file_name",
  "fee",
  "transaction_details",
];
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() );
const today = new Date();
today.setDate(today.getDate());

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminType: props.adminType,
      open: props.open,
      formData: props.formData,
      edit: props.edit,
      selectedParam: props.selectedParam,
      approveStatus: props.approveStatus,
      isActive: false,
      submitted: false,
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      open: props.open,
      edit: props.edit,
      formData: props.formData,
      selectedParam: props.selectedParam,
      approveStatus: props.approveStatus,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({ formData: { ...this.state.formData, [name]: value } });
  };
  handleTransChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: e.target.value,
      },
    }));
  };

  snackbarClose = (flag) => {
    this.setState({
      snackMessage: "",
      isSnackError: false,
      snackOpen: false,
    });
    if (!flag) {
      this.props.handleClose();
    }
  };


  handleFileChange = (e) => {
    const file = e.target.files[0];
    
    if (!file) return;
    const fileType = file.name.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png"].includes(fileType)) {
      
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (readerEvent) => {
        const image = new Image();
        image.src = readerEvent.target.result;

        image.onload = () => {
          const height = image.height;
          const width = image.width;
          if(width === 400 && height === 250){
      this.setState((prevState) => ({
        fileChange: true,
        formData: {
          ...prevState.formData,
          file_name: file.name,
          advertisement: file, 

        },

      }
    )
  );} else {
     this.setState({
              snackMessage: "Incorrect image dimensions. Required: 400x250 px",
              isSnackError: true,
              snackOpen: true,
              isActive: false,
            });
  }
}}

    } else {
      this.setState({
        snackMessage: "File should be in .jpg / .jpeg / .png format",
        isSnackError: true,
        snackOpen: true,
      });
    }

  };

  handleSubmit = (e) => {
    e.preventDefault();
    const error = FormValidate(this.state.formData, required);

    if (Object.keys(error).length === 0) {
      this.setState({ isActive: true });
      const { edit, formData } = this.state;
      const formDataToSend = new FormData();
      const formatDate = (date) => {
        if (!date) return "";
        if (typeof date === "string") return date; 
        return new Date(date).toISOString().slice(0, 10); 
      };
      Object.keys(formData).forEach((key) => {
        let value = formData[key];
        if (key === "start_date" || key === "end_date") {
          value = formatDate(value);
        }
        if (key === "advertisement") {
          if (typeof value !== "string" && value instanceof File) {
            formDataToSend.append(key, value);
          }
        }else if(key==="file_name"){
          formDataToSend.append(key,formData?.file_name)
        } 
        else {
          formDataToSend.append(key, value ?? "");
        }
      });
      const apiCall = edit
        ? admin_advertisement_update(formData.id, formDataToSend)
        : admin_advertisement_add(formDataToSend);

      apiCall
        .then((res) => {
          this.setState({
            submitted: true,
            isActive: false,
            snackMessage: res.message,
            isSnackError: false,
            snackOpen: true,
          });
        })
        .catch((error) => {
          this.setState({
            submitted: false,
            isActive: false,
            snackMessage: error.message,
            isSnackError: true,
            snackOpen: true,
          });
        });
    } else {
      this.setState({
        submitted: false,
        snackMessage: "Please fill all mandatory fields",
        isSnackError: true,
        snackOpen: true,
      });
    }
  };


  handleDatePickerChange = (e, name) => {
    let date = e.value;
    if (date) {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: date,
        },
      });
    } else {
      this.setState({
        formData: {
          ...this.state.formData,
          [name]: null,
        },
      });
    }
  };
  saMessage = (status) => {
    Swal.fire({
      title: "Message",
      input: "textarea",
      inputLabel: "Provide a reason",
      showCancelButton: true,
      confirmButtonColor: "#0A223D",
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      inputValidator: (value) => {
        if (!value.trim()) {
          return "Please describe the reason";
        }
      },
    }).then((message) => {
      if (message.isConfirmed && message.value.trim()) {
        let rpdetails = this.state.formData?.id; 

        if (!rpdetails) {
          console.error("Advertisement ID is missing.");
          this.setState({
            snackMessage: "Error: Advertisement ID is missing.",
            isSnackError: true,
            snackOpen: true,
          });
          return;
        }

        let rdata = {
          status: status,
          rp_id: rpdetails,
          revert_reason: message.value,
        };

        if (this.state.adminType === 1) {
          rdata[status === 1 ? "admin_message" : "user_message"] = message.value;
        } else {
          rdata["super_admin_message"] = message.value;
        }

        this.setState({ isActive: true });

        advertisement_revert_status(rpdetails, rdata)
          .then((res) => {
            this.setState({
              snackMessage: res?.message || "Action successful",
              isSnackError: false,
              snackOpen: true,
            });
          })
          .catch((error) => {
            this.setState({
              snackMessage:
                error.response?.data?.message || "Error processing request",
              isSnackError: true,
              snackOpen: true,
            });
          })
          .finally(() => {
            this.setState({ isActive: false });
          });
      }
    });
  };

  handleApproveStatus = (status) => {
    let data = { status: status };
    const { selectedParam } = this.state;
    this.setState({ isActive: true });
    advertisement_approve_status(selectedParam, data)
      .then((res) => {
        this.setState({
          snackMessage: res.message,
          isSnackError: false,
          snackOpen: true,
          isActive: false,
        });
      })
      .catch((error) => {
        this.setState({
          snackMessage: error.message,
          isSnackError: true,
          snackOpen: true,
          isActive: false
        });
      });
  };
  render() {
    const { submitted, formData, open, edit, isActive, adminType, selectedParam, approveStatus } = this.state;
    const { view } = this.props;

    return (
      <React.Fragment>
        {open && (
          <React.Fragment>
            <Loader open={isActive} />
            <div className="overlay">
              <div className="big-dia-scroll dialog" style={{ height: '650px' }}>
              <Snackbar
                style={{ height: "100%" }}
                message={this.state.snackMessage}
                error={this.state.isSnackError}
                open={this.state.snackOpen}
                close={this.snackbarClose}
              />
              

                <div className="row">
                  <div className="flexDisplay">
                    <div className="diaTitleCon">
                      {edit
                        ? "Edit Advertisement"
                        : view
                          ? "Advertisement"
                          : "Add Advertisement"}
                    </div>
                    <div className="dia-close" onClick={this.props.handleClose}>
                      <div className="diaCloseCon">
                        <div className="diaClose">&#10005;</div>
                      </div>
                    </div>
                  </div>
                  <div className="tilebar d-flex justify-content-start">
                    {/* <hr /> */}
                  </div>
                  <form action="">
                    <div className="row book-form">
                      <div className="">
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Title"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData.title ?? ""}
                            name="title"
                            required
                          />
                        </div>
                        <div className="col-12">

                          <TextField
                            type="file"
                            id="outlined-basic"
                            variant="outlined"
                            onChange={(e) => this.handleFileChange(e)}
                            label="Advertisement  [height:250px, width : 400px ,format: .jpg , .jpeg , .png]"
                            disabled={view}
                            fileName={formData.file_name}
                            accept=".jpg,.jpeg,.png"
                          required
                          />
                        </div>
                        
                        {/* <div className="file-up-helper ">
                          *Upload only .jpg, .jpeg format. Size should be less than 1MB (Width=90px, Height=84px).
                        </div> */}


                        <div className="col-12 not-required">
                          <DatePickerField
                            value={formData.start_date ?? null}
                            minDate={today}
                            label="Start Date"
                            required
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleDatePickerChange(e, "start_date")}
                          />

                        </div>
                        <div className="col-12 not-required">
                          <DatePickerField
                            value={formData.end_date ?? null}
                            minDate={tomorrow}
                            label="End Date"
                            variant="outlined"

                            required
                            disabled={view}
                            onChange={(e) => this.handleDatePickerChange(e, "end_date")}

                          />
                        </div>
                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Fee"
                            variant="outlined"
                            disabled={view}
                            onChange={(e) => this.handleChange(e)}
                            value={formData.fee ?? ""}
                            name="fee"
                            required
                          />
                        </div>

                        <div className="col-12">
                          <TextField
                            id="outlined-basic"
                            label="Transaction Details"
                            disabled={view}
                            onChange={(e) => this.handleTransChange(e)}
                            value={formData.transaction_details ?? ""}
                            name="transaction_details"
                            required
                            multiline
                          />

                        </div>
                        {view && formData.revert_reason !== null && formData?.status == 2 &&
                        <div className="col-12 ad-revert d-flex align-items-center">
                          <label for="exampleInputEmail1" className="col-3">
                            <b>Revert Reason</b>
                          </label>
                          <div className="m-0">
                            :
                          </div>
                          <div className="col-6 p-2 m-0">
                            {formData?.revert_reason}
                          </div>
                        </div>

                      }

                      </div>
                      {!view && (
                        <div className="col-12">
                          <CustomButton
                            label={edit ? "Update" : "Add"}
                            disabled={submitted}
                            onClick={(e) => this.handleSubmit(e)}
                          />
                        </div>
                      )}
                      {view && adminType === 2 && approveStatus === 0 && (
                        <div className="d-flex justify-content-center mt-4">
                          <button
                            type="button"
                            className="btn btn-approve btn-success mr-2"
                            onClick={() => this.handleApproveStatus(1)} 
                          >
                            Approve
                          </button>
                          <br />
                          <button
                            type="button"
                            className="btn btn-reject btn-danger"
                            onClick={() => this.saMessage(5)}
                          >
                            Revert with Reason
                          </button>
                        </div>

                      )}
                      
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default Dialog;
